import React from 'react';
import PropTypes from 'prop-types';
import { makeStyles } from '@material-ui/core/styles';
import clsx from 'clsx';
import SectionWithArrows from 'components/organisms/SectionWithArrows/SectionWithArrows';

const useStyles = makeStyles((theme) => ({
  root: {},
  pagination: {
    marginTop: theme.spacing(8),
    display: 'flex',
    justifyContent: 'center',
  },
  filterContainer: {
    marginBottom: theme.spacing(4),
  },
  content: {
    paddingTop: theme.spacing(2),
  },
  reportSelected: {
    backgroundColor: '#ECEBEB9D',
  },
  centerAlign: {
    textAlign: 'center',
  },
  commonTextSize: {
    fontSize: '17px',
  },
  secondTextSize: {
    fontSize: '20px',
  },
  titleTextSize: {
    fontSize: '22px',
    fontWeight: 'bold',
  },
  margins: {
    marginBottom: '10px',
  },
}));

const PrivacyPolicies = (props) => {
  const { className, ...rest } = props; // eslint-disable-line no-unused-vars
  const classes = useStyles();

  return (
    <div
      className={clsx(className)}
      style={{
        textAlign: 'justify',
        marginTop: '20px',
      }}
    >
      <SectionWithArrows propClasses={{ section: classes.content }}>
        <div className={clsx(classes.centerAlign, classes.titleTextSize, classes.margins)}>Politikat e Privatësisë</div>
        <div className={clsx(classes.centerAlign, classes.secondTextSize, classes.margins)}>
          FINANCAT E VETËQEVERISEJS VENDORE
        </div>
        <div className={clsx(classes.commonTextSize, classes.margins)}>
          Adminstratorët e Financat e Vetëqeverisjes Vendore kanë organizuar këtë Deklatatë të Privatësisë me qëllim për
          të shprehur angazhimin për një transparencë dhe korrektësi me përdorimin e informacionit të mbledhur dhe
          përdorur në portalin për të gjitha njësitë e vetëqeverisjes vendore në territorin e Republikës së Shqipërisë.
          Financat e Vetëqeverisjes vendore janë të programuar në përputhje me standardet WCAG 2.1 Level AA të
          direktivave të EU dhe gjithashtu në përputhje me legjislacionin Shqiptar.
        </div>

        <div className={clsx(classes.centerAlign, classes.titleTextSize, classes.margins)}>Politikat e Privatësisë</div>
        <div className={clsx(classes.commonTextSize, classes.margins)}>
          Kjo deklaratë e privatësisë është përditësuar në datën 22/12/2022, dhe është efektive nga data 22/12/2022 dhe
          është një marrëveshje mes gjithë përdoruesve dhe drejtuesve të Financave të vetëqeverisjes vendore për të
          garantuar një informacion të saktë dhe mbështetur mbi burime zyrtare të njësive të vetëqeverisjes vendore nga
          Ministria e Financave dhe Ekonomisë.
          <br />
          <br />
          Financat e Vetëqeverisjes Vendore vlerëson privatësinë e përdoruesve të saj dhe merr përsipër të ruaj në çdo
          rast atë nga keqpërdorimi dhe ballafaqimi me infomracion jo të saktë. Në këtë deklaratë të privatësisë do të
          përshkruhet me detaje informacioni që do të sigurohet nga përdoruesit e www.fvv.al dhe gjithashtu termat e
          sigurisë që merrën përsipër nga administratorët e portalit.
          <br />
          <br />
          Nëse ju keni pyetje ose komente në lidhje me deklaratën e privatësisë së Financave të Vetëqeverisjes Vendore,
          ju lutemi të na kontaktoni në <a href='mailto:someone@example.com'>info@fvv.al</a>. Deklarata është e lidhur
          ngushtë me të gjitha mënyrat e përdorimit të shërbimit dhe është objekt i seksionit Financat e Vetëqeverisjes
          Vendore, Termat dhe Kushtet e cila mund te kontrollohet në{' '}
          <a href='/terms-conditions'>www.fvv.al/termsandconditions</a>. Në asnjë rast në portalin tonë nuk do të
          kërkohet vendosja e kredencialeve dhe llogarive personale për të sigururar informacionin statistikor me
          përjashtim të aksesit në Forumin Vendor nga stafet me rol specifik të njësve të vetëqeverisjes vendore, këto
          të dhëna janë punë intelektuale e Ministrisë së Financave dhe Ekonomisë së Shqipërisë në funksion të
          transparencës së financave vendore dhe mund të aksesohen në mënyrë publike.
        </div>

        <div className={clsx(classes.centerAlign, classes.titleTextSize, classes.margins)}>
          1. Mbledhja e informacionit mbi njësitë e vetëqeverisjes vendore
        </div>
        <div className={clsx(classes.commonTextSize, classes.margins)}>
          “Informacion teknik” konsiderohet informacioni i paraqitur në formën e grafikëve, artikujve dhe publikimeve
          nga portali mbështetur mbi të dhënat zyrtare cilësore dhe sasiore të publikuara nga Ministria e Financave dhe
          Ekonomisë së Shqipërisë për pushtetin vendor.
          <br />
          <br />
          Ministria e Financave dhe Ekonomisë të dhënat zyrtare financiare të njësive të vetëqeverisjes vendore i mbledh
          dhe përpunon në mënyrë profesionale nga Drejtoria e Financave Vendore për të siguruar paraqitjen sa më të
          thjeshtë dhe të kuptueshëm për cdo përdores. Ky informacion është lehtësisht i verifikueshëm për të gjithë ata
          që do të përdorin materialet e publikuara në website, duke dërguar një kërkesë për informacionin e detajuar
          pranë Ministrisë. Të gjithë përdoruesit e portalit mund të akesesojnë informacionin në mënyrë të plotë pa
          patur nevojë krijimin e një llogarie peronale pranë Financat Vendore, me përjashtim të komunikimeve përmes
          Forumit Vendor.
          <br />
          <br />
          <strong>Përdoruesit</strong>: Portali do të ofrojnë mundësinë të gjithë profesionistëve, bashkive dhe të
          tretëve që të akesojnë dhe të shkarkojnë informacionin cilësor dhe sasior të publikuar në portal pa asnjë
          kufizim. Gjithashtu, përdoruesit mund ti drejtohen astafit administrues të portalit për pyetje dhe kërkesa
          shtesë që mund tu lindin gjatë përdorimit të të dhënave të siguruara nga portali.
          <br />
          <br />
          Informacioni i mbledhur përmes ofertave, profileve, kërkesave dhe Feedback të marrë nga përdoruesit do të jenë
          pjesë e deklaratës së privatësisë e cila i nënshtrohet të gjitha rregullave të ruajtjes së tyre në përputhje
          me legjislacionin në fuqi.
          <br />
          <br />
          <strong>Administratorët e FVV</strong>: Financat e Vetëqeverisjes Vendore si një portal i krijuar nga
          Ministria e Financave dhe Ekonomisë me mbështetjen e projektit “Financat Lokale”. Ministria do të anagzhojë
          stafin e Drejtorisë së Financave Vendore në përpunimin e informacionit i cili do të publikohet dhe gjenerohet
          për secilin përdorues. Nga përdorimi i informacionit të publikuar mund të përfitojnë të gjithë personat që
          aksesojnë portalin pa asnjë kufizim. Gjithashtu, në mënyrë të vazhdueshme administratorët do të përdorin
          feeback e siguruar nga përdoruesit për të përmirësuar shërbimet e ofruara.
          <br />
          <br />
          Bazuar mbi legjislacionin në fuqi dhe në këtë deklaratë privatësie administratorët marrin përsipër ruajtjen e
          informacionit nga keqperdorimi. Përditësimi i deklaratës së privatësisë
        </div>

        <div className={clsx(classes.centerAlign, classes.commonTextSize)}>Përditësimi i deklaratës së privatësisë</div>
        <div className={clsx(classes.centerAlign, classes.commonTextSize)}>
          -----------------------------------------------------------------------------------------------------
        </div>

        <div className={clsx(classes.commonTextSize)}>
          KJO DEKLARATË E PRIVATËSISË ËSHTË NË FUQI PËR TË GJITHA PIKAT E PËRMENDURA MË LART. MINISTRIA E FINANCAVE DHE
          EKONOMISË KA PLOTËSISHT TË DREJTËN E PËMIRËSIMIT TË KËSAJ DEKLARATE DHE PËRDITËSIMIN E SAJ ME TË DREJTAT
          KOMBËTARE DHE NDËRKOMBËTARE QË SANKIONON LIGJI PËR PËRDORIMIN E TË DHËNATVE DHE KRIMEVE KOMPJUTERIKE.
          MINISTRIA E FINANCAVE DHE EKONOMISË DO TË POSTOJË PËRDITËSIMIN E DEKLARATËS DHE INKURAJON TË GJITHË
          PËRDORUESIT TË PËRCJELLIN PRANË NESH TË GJITHA VËREJTJET DHE NË DO TI MARRIM NË SHQYRTIM PËR TI REFLEKTUAR. JU
          VAZHDONI TË PËRDORNI SHËRBIMIN TONË DHE NE DO TË RESPEKTOJMË ME KORREKTËSI DHE SERIOZITET TË GJITHA PIKAT E
          MËSIPËRME TË DEKLARATËS SË PRIVATËSISË.
        </div>
        <br />
        <div className={clsx(classes.commonTextSize)}>
          © 2022 Ministry of Finance and Economy of Albania Private Limited. All Rights Reserved
        </div>
      </SectionWithArrows>
    </div>
  );
};

PrivacyPolicies.propTypes = {
  /**
   * External classes
   */
  className: PropTypes.string,
};

export default PrivacyPolicies;
